<template>
  <v-dialog v-model="value" persistent max-width="300">
    <v-card color="deep-purple lighten-5">
      <v-card-title>
        <span>{{$t(title)}}</span>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('input',false)" icon color="error">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>{{$t(text)}}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="$emit('input',false), $emit('click:ok')"
          class="mr-4"
          color="blue darken-1"
        >{{$t(button)}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: { type: Boolean },
    title: {
      type: String,
      default() {
        return "dialog.confirm";
      },
    },
    text: {
      type: String,
      default() {
        return "dialog.delete";
      },
    },
    button: {
      type: String,
      default() {
        return "button.delete";
      },
    },
  },
};
</script>

<style>
</style>